<template>
  <v-form>
      <v-row align="center" justify="center">
          <h3><b>{{$t('json.documentclasification')}}</b></h3>
      </v-row>
      <v-row  v-for="p in BatchSettings.Classes" :key="p.Id" align="center" justify="center">
          <v-col :cols="2">
              <v-text-field clearable v-model="p.Name" @change="onChange" :label="$t('json.name')" :disabled="disable || preview" :rules="[() => !!p.Name || $t('json.ruleempty')]" required validate-on-blur></v-text-field>
          </v-col>
          <v-col :cols="2">
              <v-text-field clearable v-model="p.Value" @change="onChange" :label="$t('json.value')" :disabled="disable || preview" :rules="[() => !!p.Value || $t('json.ruleempty')]" required validate-on-blur></v-text-field>
          </v-col>
          <v-col :cols="2" style="text-align: center;">
              <v-switch style="display: inline-flex;" v-model="p.Default" @change="changeClassDefault(p)" :disabled="disable || preview" :label="$t('json.default')"></v-switch>
          </v-col>
          <v-col :cols="1" style="text-align: center;">
              <v-btn icon @click="removeProperty(BatchSettings.Classes, p)" :disabled="disable || preview"><v-icon>mdi-server-remove</v-icon></v-btn>
          </v-col>
      </v-row>
      <v-row align="center" justify="center">
          <v-col :cols="3">
              <v-btn v-show="!preview" block @click="addParameter" :disabled="disable">{{ $t('json.addclass')}}</v-btn>
          </v-col>
      </v-row>
  </v-form>
</template>

<script>
import Models from '@/Models'
export default {
  name: 'ClassSettings',
  props: {
    props: {
      type: Object,
      default: null
    },
    disable: {
      type: Boolean,
      default: false
    },
    preview: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    BatchSettings () {
      return this.props
    }
  },
  methods: {
    async changeClassDefault (p) {
      this.BatchSettings.Classes.forEach(c => {
        if (c !== p) {
          c.Default = false
        }
      })
      this.onChange()
    },
    async removeProperty (arr, p) {
      const index = arr.indexOf(p)
      if (index > -1) arr.splice(index, 1)
      this.$emit('changeSettings')
    },
    getId () {
      return Math.floor(Math.random() * 1000000)
    },
    async addParameter () {
      const c = Models.DocClass
      c.Id = this.getId()
      this.BatchSettings.Classes.push(c)
    },
    async onChange (val) {
      this.$emit('changeSettings')
    }
  }
}
</script>
